import FeaturesShowcase from '../components/FeaturesShowcase';
import PremiumFeatures from '../components/PremiumFeatures';
import CTA from '../components/CTA';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Features() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <section className="section-fade pt-16 pb-8">
        <div className="max-w-4xl mx-auto text-center px-5 lg:px-8">
          <p className="chip mb-4">All Features</p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900">
            Powerful features to run WhatsApp at scale
          </h1>
          <p className="mt-5 text-slate-600 text-lg">
            Automation, AI, analytics and inbox — in one modern platform.
          </p>
        </div>
      </section>
      <FeaturesShowcase />
      <PremiumFeatures />
      <CTA />
    </>
  );
}
